export default function() {
  this.professionalFeedback = this.job?.professionalFeedback || null
}
